const getTranslationKey = (type: string) => `game.label_${type}`;

const GRADIENTS: Record<string, string> = {
  trending: "linear-gradient(254deg, #FF8911 -11.86%, #E74A13 111.41%)",
  new: "linear-gradient(254deg, #8A1DFF -11.86%, #6100E2 111.41%)",
  "high-roller": "linear-gradient(257deg, #4B0773 0%, #FF003C 100%)",
};

const getBadge = (game?: GameFragment) => {
  if (game?.isTrending) {
    return {
      translationKey: getTranslationKey("trending"),
      color: "bg-destructive",
      gradient: GRADIENTS.trending,
    };
  }
  if (game?.isHot) {
    return {
      translationKey: getTranslationKey("hot"),
      color: "bg-black",
    };
  }
  if (game?.isNew) {
    return {
      translationKey: getTranslationKey("new"),
      color: "bg-positive",
      gradient: GRADIENTS.new,
    };
  }
  if (game?.isHighRoller) {
    return {
      translationKey: getTranslationKey("high-roller"),
      color: "bg-black",
      gradient: GRADIENTS["high-roller"],
    };
  }
  return null;
};

export default getBadge;
